import { useSelector } from 'react-redux';
import { selectSession } from '../model/selectors';
import { AdvisorDashboard, useNavigateToPage } from '..';
import { useEffect } from 'react';
import {
  logRocketIdentifyAdvisorUser,
  logRocketIdentifyClientUser,
  SessionType,
} from '@shared';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

export function Home() {
  const session = useSelector(selectSession);
  const navigateToPage = useNavigateToPage();
  const { isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    // Handle client users
    if (session.sessionType === SessionType.client && isAuthenticated) {
      const { auth0Session } = session;
      const auth0UserId = auth0Session?.authUserId;
      const clientEmail = auth0Session?.clientUser?.email;
      if (auth0UserId && clientEmail) {
        logRocketIdentifyClientUser(auth0UserId, clientEmail);
      }
      navigate('/client/home', { replace: true });
      return;
    }

    // Handle advisor users
    if (session?.advisor?.advisorId) {
      const advisorId = session.advisor.advisorId;
      logRocketIdentifyAdvisorUser(advisorId, session.advisor.advisorFirstName);
      navigateToPage(AdvisorDashboard, { advisorId });
      return;
    }
  }, [
    session.sessionType,
    session.advisor,
    isAuthenticated,
    isLoading,
    navigate,
    navigateToPage,
  ]);

  return null;
}
